'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { isServer, QueryClient, QueryClientProvider } from '@tanstack/react-query';
let browserQueryClient: QueryClient | undefined;

/**
 * Standard TanStack default-client resolution: a fresh client per request on
 * the server (so per-request cache entries never leak across SSR requests) and
 * a lazily-created singleton in the browser (reused across renders).
 */
function getDefaultQueryClient(): QueryClient {
  if (isServer) return new QueryClient();
  browserQueryClient ??= new QueryClient();
  return browserQueryClient;
}

/**
 * Wraps `children` in a react-query provider. Defaults to a package-owned
 * client, but a consumer can pass its own `client` (e.g. an app whose tree
 * already mounts a tuned client above this provider) so the two don't split
 * into separate caches.
 */
export function ReactQueryProvider(t0) {
  const $ = _c(5);
  const {
    children,
    client
  } = t0;
  let t1;
  if ($[0] !== client) {
    t1 = client ?? getDefaultQueryClient();
    $[0] = client;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <QueryClientProvider client={t1}>{children}</QueryClientProvider>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}